import { API_ROOT } from '../../config/config'
import { doGet, doPut } from './utils'

export const getProjectEvaluation = (projectVersionId, projectProgressId, evaluationId) => {
  const url = `${API_ROOT}/progress/project/evaluation/${projectVersionId}/${projectProgressId}?evaluationId=${
    evaluationId || ''
  }`
  return doGet(url)
}

export const saveProjectEvaluation = (projectVersionId, projectProgressId, request) => {
  const url = `${API_ROOT}/progress/project/evaluation/${projectVersionId}/${projectProgressId}`
  return doPut(url, request)
}
